module.exports = __webpack_public_path__ + "img/genicon-got-elected.a968b83f.svg";